module.exports = __webpack_public_path__ + "static/tensorflow-training-07b1c20721cdfe5c4b9cd79c2a9e684c.png";